import { render, staticRenderFns } from "./SelectedExamples.vue?vue&type=template&id=9df428c4&scoped=true&"
import script from "./SelectedExamples.vue?vue&type=script&lang=js&"
export * from "./SelectedExamples.vue?vue&type=script&lang=js&"
import style0 from "./SelectedExamples.vue?vue&type=style&index=0&id=9df428c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df428c4",
  null
  
)

/* custom blocks */
import block0 from "./SelectedExamples.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
